import Facility from 'visuris/Data/Entities/Facility';
import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';
import * as $ from 'jquery';
import * as app from 'CMS/core/application';
import * as facilityhelp from 'visuris/Helpers/FacilityHelper';
import RisIndex from '../Entities/RISIndex';
import RisIndexLocationSearchResult from '../Entities/RisIndexLocationSearchResult';
import { reject } from 'dojo/_base/Deferred';
import * as i18n from 'CMS/core/i18n';

export default class RISIndexRepository extends BaseRepository<RisIndex> {

    // See constructor
    private SUGGESTRISINDICES = "";
    private SUGGESTFAVORITES = "";
    public GETRISINDEXOBJECTS = "";
    private GETRISINDEXOBJECT = "";
    private GETCOUNTRIES = "";
    private GETFAIRWAYS = "";

    constructor() {
        super();
        this.SUGGESTRISINDICES = app.formatLocationUrl("~/visuris/api/RisIndices_v2/Suggest?text=");
        this.SUGGESTFAVORITES = app.formatLocationUrl("~/visuris/api/RisIndices_v2/SuggestFavorites?text=");
        this.GETRISINDEXOBJECTS = app.formatLocationUrl("~/visuris/api/RisIndices_v2/GetRISIndexObjects");
        this.GETRISINDEXOBJECT = app.formatLocationUrl("~/visuris/api/RisIndices_v2/GetRISIndexObject?isrs=");
        this.GETCOUNTRIES = app.formatLocationUrl("~/visuris/api/RisIndices_v2/GetCountries");
        this.GETFAIRWAYS = app.formatLocationUrl("~/visuris/api/RisIndices_v2/GetFairways");
    }

    public list(): Promise<RisIndex[]> {
        return new Promise<RisIndex[]>((resolve, reject) => {
            var $get = $.get(this.GETRISINDEXOBJECTS);
            $get.then((data) => {
                var risindices: RisIndex[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    risindices.push(RISIndexRepository.fromDTO(item));
                }
                resolve(risindices);
            }, () => {
                reject();
            });
        });
    }

    public get(id: any): Promise<RisIndex> {
        return new Promise<RisIndex>((resolve, reject) => {
            var $get = $.get(this.GETRISINDEXOBJECT + id);
            $get.then((data) => {
                resolve(RISIndexRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public suggest(text: string, searchRole?: number, countryCode?: string, fairway?: string, distanceMarks?: boolean, filterFunctions?: string, odataQueryParams?: string): Promise<RisIndexLocationSearchResult> {
        return new Promise<RisIndexLocationSearchResult>((resolve, reject) => {
            let params = odataQueryParams;
            if (searchRole != null) {
                params += '&searchRole=' + searchRole;
            }
            if (countryCode != null) {
                params += '&countryCode=' + countryCode;
            }
            if (fairway != null) {
                params += '&fairway=' + fairway;
            }
            if (distanceMarks) {
                params += '&distanceMarks=true';
            }
            if (filterFunctions) {
                params += '&filterFunctions=' + filterFunctions;
            }
            const $get = $.get(this.SUGGESTRISINDICES + text + params);
            $get.then((data) => {
                const locationSearchResult = RISIndexRepository.fromLocationSearchDTO(data);
                resolve(locationSearchResult);
            }, () => {
                reject();
            });
        });
    }

    public suggestFavorites(text: string, searchRole?: number): Promise<RisIndexLocationSearchResult> {
        return new Promise<RisIndexLocationSearchResult>((resolve, reject) => {
            const $get = $.get(this.SUGGESTFAVORITES + text + '&searchRole=' + searchRole);
            $get.then((data) => {
                const locationSearchResult = RISIndexRepository.fromLocationSearchDTO(data, true);
                resolve(locationSearchResult);
            }, () => {
                reject();
            });
        })
    }

    public getCountries(): Promise<object> {
        return new Promise<object>((resolve, reject) => {
            const $get = $.get(this.GETCOUNTRIES);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public getFairways(countryCode: string = null): Promise<object> {
        return new Promise<object>((resolve, reject) => {
            let params = '';
            if (countryCode) {
                params += '?countryCode=' + countryCode;
            }
            const $get = $.get(this.GETFAIRWAYS + params);
            $get.then((data) => {
                resolve(data);
            }, () => {
                reject();
            });
        });
    }

    public static fromLocationSearchDTO(item: any, isFavorited: boolean = false): RisIndexLocationSearchResult {
        const risindexLocationSearch = new RisIndexLocationSearchResult();
        risindexLocationSearch.numberOfResultsPerFunction = item.numberOfResultsPerFunction;
        risindexLocationSearch.totalNumberOfResults = item.totalNumberOfResults;
        risindexLocationSearch.results = item.results.map((x: any) => this.fromDTO(x, isFavorited));
        return risindexLocationSearch;
    }

    public static fromDTO(item: any, isFavorited: boolean = false): RisIndex {
        const risindex = new RisIndex();
        risindex.isrs = item.isrs;
        risindex.countryCode = item.countryCode;
        risindex.unloCode = item.unLocode;
        risindex.fairwayCode = item.fairwayCode;
        risindex.objectCode = item.objectCode;
        risindex.hectom = item.hectom;
        risindex.risFunction = item.function;
        risindex.objectName = item.objectName ? item.objectName : item.isrs;
        risindex.nationalObjectName = item.nationalObjectName;
        risindex.locationName = item.locationName;
        risindex.fairwayName = item.fairwayName;
        risindex.nationalFairwayName = item.nationalFairwayName;
        risindex.routeName = item.routeName;
        risindex.lat = item.lat;
        risindex.lon = item.lon;
        risindex.source = item.source;
        risindex.positionCode = item.positionCode;
        risindex.section = item.section;
        risindex.relatedISRS = item.relatedISRS;

        //full
        risindex.relatedENCs = item.relatedENCs;
        risindex.communicationInformation = item.communicationInformation;
        risindex.natGaugeCode = item.natGaugeCode;
        risindex.vesselConvoyLength = item.vesselConvoyLength;
        risindex.vesselConvoyBreadth = item.vesselConvoyBreadth;
        risindex.vesselConvoyDraught = item.vesselConvoyDraught;
        risindex.vesselConvoyAirDraught = item.vesselConvoyAirDraught;
        risindex.availableLength = item.availableLength;
        risindex.clearanceWidth = item.clearanceWidth;
        risindex.availableDepthCode = item.availableDepthCode;
        risindex.availableDepthValue = item.availableDepthValue;
        risindex.clearanceHeightCode = item.clearanceHeightCode;
        risindex.clearanceHeightValue = item.clearanceHeightValue;
        risindex.gaugeISRS = item.gaugeISRS;
        risindex.applicabilityFromKm = item.applicabilityFromKm;
        risindex.applicabilityToKm = item.applicabilityToKm;
        risindex.refL1Code = item.refL1Code;
        risindex.refL2Code = item.refL2Code;
        risindex.refL3Code = item.refL3Code;
        risindex.refL1Value = item.refL1Value;
        risindex.refL2Value = item.refL2Value;
        risindex.refL3Value = item.refL3Value;
        risindex.zeroPointCm = item.zeroPointCm;
        risindex.geodRef = item.geodRef;
        risindex.categoryOfTimeSchedule = item.categoryOfTimeSchedule;
        risindex.forShipType = item.forShipType;
        risindex.forUseOfShip = item.forUseOfShip;
        risindex.linkToExternalXmlFileTimeSchedule = item.linkToExternalXmlFileTimeSchedule;
        risindex.linkToExternalXmlFilePassageTime = item.linkToExternalXmlFilePassageTime;
        risindex.vesselConvoyLength2 = item.vesselConvoyLength2;
        risindex.vesselConvoyBreadth2 = item.vesselConvoyBreadth2;
        risindex.vesselConvoyDraught2 = item.vesselConvoyDraught2;
        risindex.vesselConvoyAirDraught2 = item.vesselConvoyAirDraught2;
        risindex.availableLength2 = item.availableLength2;
        risindex.clearanceWidth2 = item.clearanceWidth2;
        risindex.availableDepthCode2 = item.availableDepthCode2;
        risindex.availableDepthValue2 = item.availableDepthValue2;
        risindex.clearanceHeightCode2 = item.clearanceHeightCode2;
        risindex.clearanceHeightValue2 = item.clearanceHeightValue2;
        risindex.gaugeISRS2 = item.gaugeISRS2;
        risindex.vesselConvoyLength3 = item.vesselConvoyLength3;
        risindex.vesselConvoyBreadth3 = item.vesselConvoyBreadth3;
        risindex.vesselConvoyDraught3 = item.vesselConvoyDraught3;
        risindex.vesselConvoyAirDraught3 = item.vesselConvoyAirDraught3;
        risindex.availableLength3 = item.availableLength3;
        risindex.clearanceWidth3 = item.clearanceWidth3;
        risindex.availableDepthCode3 = item.availableDepthCode3;
        risindex.availableDepthValue3 = item.availableDepthValue3;
        risindex.clearanceHeightCode3 = item.clearanceHeightCode3;
        risindex.clearanceHeightValue3 = item.clearanceHeightValue3;
        risindex.gaugeISRS3 = item.gaugeISRS3;
        risindex.categoryOfTimeSchedule2 = item.categoryOfTimeSchedule2;
        risindex.forShipType2 = item.forShipType2;
        risindex.forUseOfShip2 = item.forUseOfShip2;
        risindex.linkToExternalXmlFileTimeSchedule2 = item.linkToExternalXmlFileTimeSchedule2;
        risindex.linkToExternalXmlFilePassageTime2 = item.linkToExternalXmlFilePassageTime2;
        risindex.categoryOfTimeSchedule3 = item.categoryOfTimeSchedule3;
        risindex.forShipType3 = item.forShipType3;
        risindex.forUseOfShip3 = item.forUseOfShip3;
        risindex.linkToExternalXmlFileTimeSchedule3 = item.linkToExternalXmlFileTimeSchedule3;
        risindex.linkToExternalXmlFilePassageTime3 = item.linkToExternalXmlFilePassageTime3;
        risindex.dateBegLoc = new Date(item.dateBegLoc);
        risindex.dateEndLoc = new Date(item.dateEndLoc);
        risindex.dateInfo = new Date(item.dateInfo);
        risindex.source = item.source;
        risindex.reason = item.reason;
        risindex.relatedObjectName = item.relatedObjectName;
        risindex.gaugeObjectName = item.gaugeObjectName;
        risindex.searchPriority = item.searchPriority;

        //refdata
        risindex.functionMessage = isFavorited ? i18n.getMessage('VisuRIS.Directions.FavoriteFunctionGroup') : item.functionMessage; // needed to group in location search
        risindex.countryCodeMessage = item.countryCodeMessage;
        risindex.positionCodeMessage = item.positionCodeMessage;
        risindex.refL1CodeMessage = item.refL1CodeMessage;
        risindex.refL2CodeMessage = item.refL2CodeMessage;
        risindex.refL3CodeMessage = item.refL3CodeMessage;
        risindex.geodRefMessage = item.geodRefMessage;
        risindex.availableDepthCodeMessage = item.availableDepthCodeMessage;
        risindex.clearanceHeightCodeMessage = item.clearanceHeightCodeMessage;
        risindex.translatedFairwayName = item.translatedFairwayName;

        risindex.gisInfo = item.gisInfo;

        risindex.isFavorited = isFavorited;
        return risindex;
    }
}

